export enum ClarityType {
  Fraud,
  Behavioral,
  None,
}
